import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AtividadeUsuarioService {
  constructor() {}

  registrar() {
    localStorage.setItem("Update", JSON.stringify(Date.now()));
  }
}
